<nav>
  <ol>
    @for (mod of modules; track mod) {
      <li id="mod-nav-{{mod.Id}}">
        @if (mod.IsDisabled) {
          <div class="lock-block">
            <icon name="lock"></icon>
          </div>
        }
        <button class="module-btn" (click)="handleModuleSelect(mod)" [class.selected]="mod.IsSelected">
          <div class="top-section">
            <div class="bubble" [class.empty]="!mod.SelectionHasBeenMade && !mod.SelectionIsRequired && !mod.SelectionIsLocked"
              [class.warning]="!mod.SelectionHasBeenMade && mod.SelectionIsRequired" [class.locked]="mod.SelectionIsLocked">
              @if (!mod.SelectionIsLocked && (!mod.SelectionIsRequired || mod.SelectionHasBeenMade)) {
                <icon name="check"></icon>
              }
              @if (!mod.SelectionIsLocked && mod.SelectionIsRequired && !mod.SelectionHasBeenMade) {
                <icon name="exclamation"></icon>
              }
              @if (mod.SelectionIsLocked) {
                <icon name="lock"></icon>
              }
            </div>
            <p class="subtitle">{{mod.Subtitle}}</p>
          </div>
          <div class="bottom-section">
            <h3>{{mod.Title}}</h3>
            @if (mod.HasQuickSummaryBtn) {
              <button class="summary-btn" [class.open]="mod.SummaryIsShown"
                (click)="handleModuleSummaryToggle($event, mod)">
                @if (!mod.SummaryIsShown) {
                  <icon name="hamburger"></icon>
                }
                @if (mod.SummaryIsShown) {
                  <icon name="x"></icon>
                }
              </button>
            }
          </div>
        </button>
        @if (mod.SummaryIsShown) {
          <hc-module-summary [showCloseBtn]="false" [summary]="mod.Summary" @enterLeaveFadeAndSlideAnimation>
          </hc-module-summary>
        }
      </li>
    }
  </ol>
</nav>